<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total>0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{total}}</b>
        <span style="padding:5px;">Total Price:</span>
        <b>${{totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</b>

        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel();"
        >
          <div style="display:inline-block;" v-if="loading2019" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce bouncing2">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>

      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "./Table.vue";

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "productModel",
    "prg",
    "clients",
    "failure",
    "fns_part"
  ],
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      locationParam: "",
      excelDownloadUrl: "",
      excelDownloadParams: {
        xml: "true",
      },
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true },
        { key: "price", label: "Price", sortable: true }
      ]
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      const params = this.excelDownloadParams;
      this.$http
        .get(this.excelDownloadUrl, { params, responseType: "blob" })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    setExcelDownloadData(url, params){
      this.excelDownloadUrl = url;
      this.excelDownloadParams = {...params, xml: "true"};
    },
    getApiData(url, params){
      this.setExcelDownloadData(url, params);
      this.$http
        .get(url, { params })
        .then(
          res => {
            this.data = res.data.records;
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataReceived() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/recieved.php", params);
    },
    fetchChartDataShipped() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/shipped.php", params);
    },
    fetchChartDataCityPerGroup() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.prg,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/shipped.php", params);
    },
    fetchChartDataBer() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/ber.php", params);
    },
    fetchChartDataEol() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/eol.php", params);
    },
    fetchChartDataNtf() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/ntf.php", params);
    },
    fetchChartDataWar() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/war.php", params);
    },
    fetchChartDataOem() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.getApiData("api/aoi/tables/oem_backlog.php", params);
    },
    fetchChartDataOemShipped() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/oem_delivered.php", params);
    },
    fetchChartDatabacklog() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam
      };
      this.getApiData("api/aoi/tables/back.php", params);
    },
    fetchSubBacklog() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.getApiData("api/aoi/tables/subdivision_backlog.php", params);
    },
    fetchSubDelivered() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/aoi/tables/subdivision_delivered.php", params);
    },
    fetchChartDataPart() {
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.getApiData("api/aoi/tables/failureDataByPart.php", params);
    },
    fetchChartDataComplaint(){
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.getApiData("api/aoi/tables/failureDataByComplaint.php", params);
    },
    fetchChartDataFailure(){
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.getApiData("api/aoi/tables/failureDataByFailure.php", params);
    },
    fetchChartDataDesignator(){
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
      };
      this.getApiData("api/aoi/tables/failureDataByDesignator.php", params);
    }
  },
  watch : {
    data: function () {
      this.loading = false;
      if (this.data===undefined){
        this.title = "No data found"
      }
    }
  },
  mounted() {
    if (this.type != "top") {
      if (this.location){
        this.locationParam = this.location.substring(
          0,
          this.location.lastIndexOf("(")
        );
      }
      if (this.productGroup){
        this.productGroupParam = this.productGroup.substring(
          0,
          this.productGroup.lastIndexOf("(")
        );
      }

      if(this.productModel) {
        this.modelParam = this.productModel.substring(
          0,
          this.productModel.lastIndexOf("(")
        );
      }

      if (this.locationParam) {
        this.title =
          this.type.toLocaleUpperCase() +
          " - " +
          this.productGroupParam +
          " in " +
          this.locationParam;
      }
      else {
        this.title = this.type.toLocaleUpperCase();
      }


    } else {
      this.locationParam = this.location;
      this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
      this.title = this.prg + " Shipped to " + this.locationParam;
    }
    this.clientsId = this.clients;
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;

    if (this.type === "Received") {
      this.fetchChartDataReceived();
    }
    if (this.type === "Shipped") {
      this.fetchChartDataShipped();
    }
    if (this.type === "top") {
      this.fetchChartDataShipped();
    }
    if (this.type === "OEM") {
      this.fetchChartDataOem();
    }
    if (this.type === "OEMShip") {
      this.fetchChartDataOemShipped();
    }
    if (this.type === "ber") {
      this.fetchChartDataBer();
    }
    if (this.type === "eol") {
      this.fetchChartDataEol();
    }
    if (this.type === "ntf") {
      this.fetchChartDataNtf();
    }
    if (this.type === "war") {
      this.fetchChartDataWar();
    }
    if (this.type === "backlog") {
      this.fetchChartDatabacklog();
    }
    if (this.type === "city") {
      this.fetchChartDataCityPerGroup();
    }
    if (this.type === "SubDivisionBacklog") {
      this.fetchSubBacklog();
    }
    if (this.type === "SubDivisionDelivered") {
      this.fetchSubDelivered();
    }
    let typeSplit = this.type.split("(");
    if(typeSplit[0]==="Part"){
      this.title="Failure By Part";
      this.fetchChartDataPart();
    }
    if(typeSplit[0]==="Complaint"){
      this.title="Failure By Complaint";
      this.fetchChartDataComplaint();
    }
    if(typeSplit[0]==="Failure"){
      this.title="Failure By Failure";
      this.fetchChartDataFailure();
    }
    if(typeSplit[0]==="Designator"){
      this.title="Failure By Designator";
      this.fetchChartDataDesignator();
    }

  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  display: inline-block;
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
